var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 80.209C26.1818 76.2077 29.1017 74.149 32.7514 72.4973C51.8461 63.8551 70.8829 55.0733 89.9313 46.3264C96.6167 43.2557 103.314 43.2208 109.999 46.2799C129.662 55.2943 149.324 64.3087 168.998 73.3231C172.81 75.0679 175.012 77.9292 175 82.2329C174.977 86.5365 172.717 89.3397 168.917 91.0844C149.336 100.052 129.766 109.043 110.196 118.023C103.36 121.163 96.5588 121.105 89.7111 117.953C70.4542 109.078 51.1973 100.204 31.8824 91.4566C28.4412 89.898 26.0776 87.6531 25.0116 84.0357V80.209H25Z",
    fill: "#E98432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.891 111.532C146.891 112.94 146.891 114.196 146.891 115.452C146.891 120.838 146.937 126.235 146.891 131.62C146.81 139.774 143.021 145.659 135.745 149.114C127.495 153.034 118.77 155.36 109.698 156.407C93.9518 158.221 78.8777 155.755 64.4987 149.219C57.1296 145.869 53.2481 139.913 53.167 131.701C53.0975 125.037 53.1554 118.383 53.1554 111.498C53.7232 111.73 54.1519 111.881 54.569 112.068C64.9274 116.825 75.2974 121.559 85.6442 126.351C95.2611 130.806 104.843 130.783 114.449 126.351C124.807 121.57 135.177 116.825 145.535 112.056C145.929 111.881 146.335 111.742 146.891 111.521V111.532Z",
    fill: "#F4C135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.638 102.855V104.368C165.638 113.917 165.638 123.466 165.638 133.016C165.638 136.098 163.692 138.18 160.876 138.157C158.165 138.134 156.276 136.017 156.276 133.016C156.276 124.839 156.288 116.662 156.253 108.473C156.253 107.52 156.485 107.02 157.423 106.624C160.146 105.473 162.799 104.17 165.65 102.855H165.638Z",
    fill: "#F4C135"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 113,
    fill: "white",
    transform: "translate(25 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/Education.15eab047c31e71b7fa076a528f525ec2.svg";
export { ForwardRef as ReactComponent };